import { Search, Globe, TrendingUp, ChevronRight } from 'lucide-react';

export default function Industries() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold">Browse Industries</h1>
        <p className="text-neutral-500 dark:text-neutral-400 text-sm">Explore market trends and industry-specific data.</p>
      </header>
      
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400 dark:text-neutral-500" />
        <input 
          type="text" 
          placeholder="Search industries..." 
          className="w-full pl-10 pr-4 py-2 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-neutral-900/5 transition-all"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {['Technology', 'Healthcare', 'Finance', 'Manufacturing', 'Retail', 'Energy'].map((industry) => (
          <div key={industry} className="bg-white dark:bg-neutral-900 p-6 rounded-2xl border border-neutral-200 dark:border-neutral-800 hover:border-neutral-900 transition-all cursor-pointer group">
            <div className="flex items-center justify-between mb-2">
              <div className="p-2 rounded-lg bg-neutral-50 dark:bg-neutral-950 group-hover:bg-neutral-900 group-hover:text-white transition-all">
                <Globe className="w-5 h-5" />
              </div>
              <TrendingUp className="w-4 h-4 text-emerald-500" />
            </div>
            <h3 className="font-bold">{industry}</h3>
            <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">Market growth: +12.4%</p>
            <div className="mt-4 flex items-center text-xs font-bold text-neutral-900 dark:text-neutral-50">
              View Details <ChevronRight className="w-3 h-3 ml-1" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
